import React, { useState } from 'react'
import { FetchAbandonedCart } from '../../types'
import { t } from 'i18next'
import AbandonedCartDropDown from '../DropDowns/AbandonedCartDropDown'

interface Props {
  AbandonedCart?: FetchAbandonedCart
  direction: string
  startingIndex: number
}

type checkedItems = {
  id: string,
}

const AbandonedCartTable = ({ AbandonedCart, direction, startingIndex }: Props) => {
  const [checkedItems, setCheckedItems] = useState<checkedItems[]>([]);

  const handleCheckAll = () => {
    if (AbandonedCart?.abandonedCart.length !== checkedItems.length) {
      AbandonedCart !== undefined && setCheckedItems(AbandonedCart?.abandonedCart.map(brand => ({ id: brand.id })))
    } else {
      setCheckedItems([])
    }
  };

  const handleCheck = (id: string) => {
    const isItemExist = checkedItems.some(item => item.id === id);

    if (isItemExist) {
      const newChckedItems = checkedItems.filter(item => item.id !== id);
      setCheckedItems(newChckedItems);
    } else {
      setCheckedItems([...checkedItems, { id: id }])
    }
  };

  return (
    <table className="w-full divide-y divide-gray-200">
      <thead className="bg-gray-50">
        <tr>
          <th scope="col" className="py-3.5 px-4 text-sm text-left rtl:text-right text-gray-500">
            <div className='relative flex'>
              <input type="checkbox" checked={AbandonedCart?.abandonedCart.length === checkedItems.length} onChange={handleCheckAll} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
              <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                <polyline points="20 6 9 17 4 12"></polyline>
              </svg>
            </div>
          </th>

          <th scope="col" className="py-3.5 px-3 text-sm font-normal whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('clientName')}
          </th>

          <th scope="col" className="px-10 py-3.5 text-sm font-normal whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('date')}
          </th>

          <th scope="col" className="px-3 py-3.5 text-sm font-normal whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('productsNumber')}
          </th>

          <th scope="col" className="px-3 py-3.5 text-sm font-normal whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('cartValue')}
          </th>

          <th scope="col" className="px-3 py-3.5 text-sm font-normal whitespace-nowrap text-left rtl:text-right text-gray-500">
            {t('option')}
          </th>
        </tr>
      </thead>

      <tbody className="bg-white divide-y divide-gray-200">
        {AbandonedCart?.abandonedCart.slice(startingIndex, startingIndex + 10).map((abandonedCart, index) => {
          return (
            <tr key={index}>
              <td className="px-4 py-3 text-sm text-left text-gray-500 rtl:text-right">
                <div className='relative flex'>
                  <input type="checkbox" checked={checkedItems.some(checkedItem => checkedItem.id === abandonedCart.id)} onChange={() => handleCheck(abandonedCart.id)} className="relative w-4 h-4 border border-gray-300 rounded appearance-none peer bg-gray-50 checked:bg-primary checked:border-0" />
                  <svg className="absolute w-4 h-4 p-0.5 text-white hidden peer-checked:block pointer-events-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              </td>
              <td className="px-4 py-3 text-sm">
                <div>
                  <h2 className="text-gray-800">{abandonedCart?.client?.name}</h2>
                </div>
              </td>
              <td className="px-10 py-3 text-sm">
                <p className="text-gray-500">{new Date(abandonedCart.createdAt).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })}</p>
              </td>
              <td className="px-3 py-4 text-sm">
                <div>
                  <p className="text-gray-500">{abandonedCart.cartProducts.length}</p>
                </div>
              </td>
              <td className="px-3 py-4 text-sm">
                <p className="text-gray-500">
                  ${abandonedCart.total}
                </p>
              </td>

              <td className="px-3 py-4 text-sm">
                <AbandonedCartDropDown id={abandonedCart.id} direction={direction} />
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default AbandonedCartTable